import { COUNTRIES } from '@wareclouds/frontend-common';

import { CONTEXT } from '../../../../config/consts/commons';
import { applyProfilePhoneMask } from '../utils';

export function useProfilePhoneMask() {
  const placeholderKey =
    CONTEXT === COUNTRIES.CL
      ? 'complete_profile.form.phone.placeholder_cl'
      : 'complete_profile.form.phone.placeholder_br';

  return {
    applyMask: applyProfilePhoneMask,
    placeholderKey,
  };
}
